"use strict";
isTouchDevice.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchDevice = void 0;
var angular = require("angular");
/* @ngInject */
function isTouchDevice($window) {
    var predicat = function () {
        return 'ontouchstart' in $window || $window.navigator.maxTouchPoints > 0 || $window.navigator.msMaxTouchPoints > 0;
    };
    return {
        restrict: 'A',
        link: function ($scope, $element) {
            if (predicat()) {
                angular.element($element).addClass('feature-touch');
            }
            else {
                angular.element($element).addClass('feature-no-touch');
            }
        },
    };
}
exports.isTouchDevice = isTouchDevice;
